export default __webpack_public_path__ + "static/media/WordWork_09.de7da93d.png";